<footer
  class="bg-base-300 text-base-content border-t border-base-content/10 py-8 px-4 sm:px-6"
  role="contentinfo"
>
  <div
    class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-8 w-full max-w-[1200px] mx-auto"
  >
    <!-- Бренд -->
    <aside class="flex flex-col gap-2">
      <a
        routerLink="/"
        class="flex items-center gap-2.5 link link-accent link-hover w-fit"
        aria-label="Q-SPA — на главную"
      >
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10">
          <lucide-icon name="brain" class="h-5 w-5 text-primary stroke-[2.5]" />
        </div>
        <span class="text-xl font-semibold tracking-tight">Q-SPA</span>
      </a>
      <p class="text-sm text-base-content/70 max-w-xs">
        Функциональная диагностика и навигация саморегуляции в конкретных жизненных ситуациях
      </p>
    </aside>

    <!-- Навигация -->
    <nav class="flex flex-col gap-4 sm:flex-row sm:gap-8" aria-label="Основная навигация">
      <div class="flex flex-col gap-2" role="group" aria-label="Навигация">
        <span class="text-sm font-semibold text-base-content">Навигация</span>
        <ul class="flex flex-col gap-1">
          <li>
            <a routerLink="/" class="link link-hover link-accent">Главная</a>
          </li>
          @if (blogNavStore.hasPublishedBlogContent()) {
            <li>
              <a [routerLink]="routes.blog" class="link link-hover link-accent">Блог</a>
            </li>
          }
          @if (authStore.isAuthenticated()) {
            <li>
              <a [routerLink]="routes.questionnaire" class="link link-hover link-accent"
                >Опросник</a
              >
            </li>
            <li>
              <a [routerLink]="routes.dailyReflection" class="link link-hover link-accent"
                >Ежедневная рефлексия</a
              >
            </li>
            <li>
              <a [routerLink]="routes.history" class="link link-hover link-accent">История</a>
            </li>
            <li>
              <a [routerLink]="routes.reference" class="link link-hover link-accent">Справочник</a>
            </li>
          } @else {
            <li>
              <a [routerLink]="routes.login" class="link link-hover link-accent">Вход</a>
            </li>
            <li>
              <a [routerLink]="routes.register" class="link link-hover link-accent">Регистрация</a>
            </li>
          }
        </ul>
      </div>

      @for (group of infoPages.groups(); track group.id) {
        <div class="flex flex-col gap-2" role="group" [attr.aria-label]="group.title">
          <span class="text-sm font-semibold text-base-content">{{ group.title }}</span>
          <ul class="flex flex-col gap-1">
            @for (page of group.pages; track page.id) {
              <li>
                <a
                  [routerLink]="['/' + infoPageRoute, page.slug]"
                  class="link link-hover link-accent"
                  >{{ page.title }}</a
                >
              </li>
            }
          </ul>
        </div>
      }
    </nav>
  </div>
</footer>
